var render = function render(){
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-grow-1"
  }, [_c('v-col', {
    attrs: {
      "cols": _vm.cols[0],
      "offset": _vm.offset[0]
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.labelGre,
      "items": _vm.form.lists.gres,
      "item-text": 'nome',
      "multiple": _vm.multiple,
      "rules": [function (v) {
        return _this.isGreRequired(v);
      }],
      "disabled": _vm.disabled,
      "outlined": "",
      "dense": "",
      "return-object": ""
    },
    model: {
      value: _vm.reactiveValue.gre,
      callback: function ($$v) {
        _vm.$set(_vm.reactiveValue, "gre", $$v);
      },
      expression: "reactiveValue.gre"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.cols[1],
      "offset": _vm.offset[1]
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.computedListMunicipios,
      "item-text": 'nome',
      "label": _vm.labelMunicipio,
      "multiple": _vm.multiple,
      "rules": [function (v) {
        return _this.isMunicipioRequired(v);
      }],
      "outlined": "",
      "dense": "",
      "return-object": "",
      "disabled": _vm.disabled || _vm.disabledMunicipio
    },
    model: {
      value: _vm.reactiveValue.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.reactiveValue, "municipio", $$v);
      },
      expression: "reactiveValue.municipio"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }